import React, {useEffect, useContext, useState} from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import jssPreset from '@mui/styles/jssPreset';
import makeStyles from '@mui/styles/makeStyles';
import StylesProvider from '@mui/styles/StylesProvider';
import ScrollReset from './components/ScrollReset';
import { createConfigTheme } from './theme';
import ServiceDeskRoutes from './ServiceDeskRoutes';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import authService from "./services/authService";
import SplashScreen from "./components/SplashScreen";
import Auth from "./components/Auth";

const history = createBrowserHistory();
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const useStyles = makeStyles(() => createStyles({
  '@global': {
    '*': {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
    },
    html: {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      height: '100%',
      width: '100%'
    },
    body: {
      height: '100%',
      width: '100%'
    },
    '#root': {
      height: '100%',
      width: '100%'
    }
  }
}));


function App() {
  useStyles();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={createConfigTheme()}>
        <StylesProvider jss={jss}>
          <SnackbarProvider maxSnack={1}>
              <BrowserRouter basename="/" history={history}>
                <Auth>
                  <ScrollReset />
                  <ServiceDeskRoutes />
                </Auth>
              </BrowserRouter>
          </SnackbarProvider>
        </StylesProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
